import React from 'react';

import checkOverflow from '../utils/checkModalOverflow';

class CancelShiftModal extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    render() {
        let classes = "modal-overlay cancel-shift-modal-overlay";
        let content = null;
        if (this.props.hired_candidates > 0) {
            content = this.getHiredContent();
        } else if (this.props.pending_candidates > 0) {
            content = this.getPendingContent();
        }
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.props.toggleModal} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>Cancel shift</h1>
                        <button className="close" onClick={this.props.toggleModal}><span>&times;</span></button>
                    </header>

                    <div className="modal-content">
                        <h3 className="modal-content-section-title">Are you sure?</h3>
                        {content}

                        <div className="buttons">
                            <button onClick={this.cancelShift.bind(this)} className="btn btn-green btn-small">Cancel shift</button>
                            <button onClick={this.props.toggleModal} className="btn-transparent">Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getPendingContent() {
        return (
            <p>All applied candidates will be declined.</p>
        );
    }

    getHiredContent() {
        return (
            <div>
                <p>
                    Use Cancellation only if there is no other possibility. Fees still apply.
                    Please include a message to the approved candidates with the reason for cancelling.
                </p>
                <div className={"message" + (this.props.messageError ? " has-error" : "")}>
                    <div className="label-title">Message for the candidates</div>
                    <textarea onChange={this.props.changeCancelMessage} className="cancel-shift-editor" />
                    <span className="error-block">Please write a message with an explanation to the candidates</span>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    cancelShift() {
        this.props.cancelShift();
        checkOverflow(0);
    }
}

export default CancelShiftModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/CancelShiftModal.js
 **/